module.exports = __webpack_public_path__ + "media/images/1000px_Top_Logo_Banner_NoBalls-0b4ba4dca13936df831c495e38a58961.png";